module.exports = __webpack_public_path__ + "static/media/pharos-logo-light.6ce4cccf.webp";